import { PlanFeature, SubscriptionItems } from "refsix-js-models";

// assume if the provider is apple, google, or stripe, it's a paid subscription.
// Register free trial and complementary subscriptions use the provider refsix.
export const PAID_SUBSCRIPTION_PROVIDERS = ["apple", "google", "stripe"];

export function isSubscriptionPaid(provider: string): boolean {
    return PAID_SUBSCRIPTION_PROVIDERS.includes(provider);
}

// Stoppages are recorded for everyone; listing them needs the plan feature and the user's setting
export function showsStoppagesInMatchLog(
    features: string[] | undefined,
    showStoppagesInMatchLog: boolean | undefined
): boolean {
    return (
        !!features &&
        features.indexOf(PlanFeature.stoppageEvents) >= 0 &&
        showStoppagesInMatchLog === true
    );
}

export function hasPaidSubscription(
    subscriptions: SubscriptionItems[]
): boolean {
    for (const subscription of subscriptions) {
        if (isSubscriptionPaid(subscription.provider)) {
            return true;
        }
    }
    return false;
}
